/* ShopDoorMate: Porch Preview. Everything happens on the shopper's device; photos are never uploaded. */
(function () {
  'use strict';
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const MAX_SIDE = 1600;

  function loadImg(src) { return new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; }); }

  class PorchPreview {
    constructor(root) {
      this.root = root;
      this.canvas = root.querySelector('[data-porch-canvas]');
      this.ctx = this.canvas.getContext('2d');
      this.mats = [];
      try { this.mats = JSON.parse(document.getElementById(root.dataset.matsJson).textContent).filter(m => m.available !== false); } catch (e) {}
      this.sample = root.dataset.sample;
      this.photo = null; this.matCanvas = null; this.mat = null;
      this.state = { cx: 0.5, cy: 0.8, w: 0.4, rot: 0, tilt: 0.45 };
      this.pointers = new Map();
      this.buildPicker();
      this.bind();
      const first = root.dataset.initial && this.mats.find(m => m.handle === root.dataset.initial) || this.mats[0];
      this.loadSample().then(() => first && this.selectMat(first.handle));
    }
    $(s) { return this.root.querySelector(s); }
    toast(html, ms) {
      const t = this.$('[data-porch-toast]'); if (!t) return;
      t.innerHTML = html; t.hidden = false; clearTimeout(this._tt);
      if (ms) this._tt = setTimeout(() => { t.hidden = true; }, ms);
    }
    buildPicker() {
      const wrap = this.$('[data-porch-picker]'); if (!wrap) return;
      wrap.innerHTML = '';
      this.mats.forEach(m => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'sdm-porch__mat'; b.dataset.handle = m.handle; b.setAttribute('aria-label', 'Try ' + m.title);
        const img = document.createElement('img'); img.src = m.img; img.alt = ''; img.loading = 'lazy'; img.width = 120; img.height = 68;
        const s = document.createElement('span'); s.textContent = m.title;
        b.append(img, s);
        b.addEventListener('click', () => this.selectMat(m.handle));
        wrap.appendChild(b);
      });
    }
    bind() {
      const r = this.root;
      r.querySelectorAll('[data-porch-file]').forEach(inp => inp.addEventListener('change', (e) => { const f = e.target.files && e.target.files[0]; if (f) this.loadFile(f); e.target.value = ''; }));
      r.querySelectorAll('[data-porch-sample]').forEach(b => b.addEventListener('click', () => this.loadSample()));
      const sliders = { size: 'w', turn: 'rot', tilt: 'tilt' };
      Object.entries(sliders).forEach(([name, key]) => {
        const el = r.querySelector(`[data-porch-slider="${name}"]`); if (!el) return;
        el.addEventListener('input', () => { this.state[key] = name === 'turn' ? (+el.value) * Math.PI / 180 : +el.value; this.draw(); });
      });
      const reset = r.querySelector('[data-porch-reset]'); if (reset) reset.addEventListener('click', () => { this.resetPlacement(); this.draw(); });
      const save = r.querySelector('[data-porch-save]'); if (save) save.addEventListener('click', () => this.save());
      const add = r.querySelector('[data-porch-add]'); if (add) add.addEventListener('click', () => this.addToCart(add));
      const c = this.canvas;
      c.addEventListener('pointerdown', (e) => { c.setPointerCapture && c.setPointerCapture(e.pointerId); this.pointers.set(e.pointerId, this.pt(e)); this.startGesture(); e.preventDefault(); });
      c.addEventListener('pointermove', (e) => { if (!this.pointers.has(e.pointerId)) return; this.pointers.set(e.pointerId, this.pt(e)); this.moveGesture(); e.preventDefault(); });
      const up = (e) => { this.pointers.delete(e.pointerId); this.startGesture(); };
      c.addEventListener('pointerup', up); c.addEventListener('pointercancel', up);
      c.addEventListener('wheel', (e) => { e.preventDefault(); this.state.w = clamp(this.state.w * (e.deltaY < 0 ? 1.06 : 0.94), 0.08, 1.2); this.syncSliders(); this.draw(); }, { passive: false });
      window.addEventListener('resize', () => this.draw());
    }
    pt(e) { const b = this.canvas.getBoundingClientRect(); return { x: (e.clientX - b.left) / b.width, y: (e.clientY - b.top) / b.height }; }
    startGesture() {
      const ps = [...this.pointers.values()];
      this.g = { s: { ...this.state }, ps: ps.map(p => ({ ...p })) };
      if (ps.length === 2) { const a = this.canvas.width / this.canvas.height; this.g.d = Math.hypot((ps[0].x - ps[1].x) * a, ps[0].y - ps[1].y); this.g.ang = Math.atan2(ps[1].y - ps[0].y, (ps[1].x - ps[0].x) * a); this.g.mid = { x: (ps[0].x + ps[1].x) / 2, y: (ps[0].y + ps[1].y) / 2 }; }
    }
    moveGesture() {
      const ps = [...this.pointers.values()], g = this.g; if (!g) return;
      if (ps.length === 1 && g.ps.length === 1) {
        this.state.cx = clamp(g.s.cx + ps[0].x - g.ps[0].x, 0, 1); this.state.cy = clamp(g.s.cy + ps[0].y - g.ps[0].y, 0, 1);
      } else if (ps.length === 2 && g.d) {
        const a = this.canvas.width / this.canvas.height;
        const d = Math.hypot((ps[0].x - ps[1].x) * a, ps[0].y - ps[1].y), ang = Math.atan2(ps[1].y - ps[0].y, (ps[1].x - ps[0].x) * a);
        const mid = { x: (ps[0].x + ps[1].x) / 2, y: (ps[0].y + ps[1].y) / 2 };
        this.state.w = clamp(g.s.w * d / g.d, 0.08, 1.2);
        this.state.rot = g.s.rot + (ang - g.ang);
        this.state.cx = clamp(g.s.cx + mid.x - g.mid.x, 0, 1); this.state.cy = clamp(g.s.cy + mid.y - g.mid.y, 0, 1);
      }
      this.syncSliders(); this.draw();
    }
    syncSliders() {
      const r = this.root, s = this.state;
      const set = (n, v) => { const el = r.querySelector(`[data-porch-slider="${n}"]`); if (el) el.value = v; };
      set('size', s.w.toFixed(3)); set('turn', Math.round(((s.rot * 180 / Math.PI) + 540) % 360 - 180)); set('tilt', s.tilt);
    }
    resetPlacement() { this.state = { cx: 0.5, cy: 0.8, w: this.photoIsPortrait() ? 0.62 : 0.4, rot: 0, tilt: 0.45 }; this.syncSliders(); }
    photoIsPortrait() { return this.photo && this.photo.height > this.photo.width; }
    async setPhoto(img) {
      const s = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height));
      const w = Math.round((img.naturalWidth || img.width) * s), h = Math.round((img.naturalHeight || img.height) * s);
      const off = document.createElement('canvas'); off.width = w; off.height = h; off.getContext('2d').drawImage(img, 0, 0, w, h);
      this.photo = off; this.canvas.width = w; this.canvas.height = h;
      this.root.classList.add('has-photo');
      this.resetPlacement(); this.draw();
    }
    async loadSample() { try { await this.setPhoto(await loadImg(this.sample)); this.toast('Sample porch loaded. Snap or upload yours to see it on <b>your</b> door!', 3500); } catch (e) {} }
    async loadFile(file) {
      if (!/^image\//.test(file.type)) { this.toast('That file is not a photo. Try a JPG or PNG.', 3000); return; }
      const url = URL.createObjectURL(file);
      try { await this.setPhoto(await loadImg(url)); this.toast('Looking good! Drag the mat onto your doorstep.', 3000); }
      catch (e) { this.toast('Hmm, that photo did not open. Try another one.', 3000); }
      finally { URL.revokeObjectURL(url); }
    }
    async selectMat(handle) {
      const m = this.mats.find(x => x.handle === handle); if (!m) return;
      this.mat = m;
      this.root.querySelectorAll('.sdm-porch__mat').forEach(b => b.classList.toggle('is-active', b.dataset.handle === handle));
      const nm = this.$('[data-porch-name]'); if (nm) nm.textContent = m.title;
      const add = this.$('[data-porch-add]'); if (add) {
        if (!add.dataset.origHtml) add.dataset.origHtml = add.innerHTML;
        add.innerHTML = add.dataset.origHtml;
        if (m.pz) add.innerHTML = '<span aria-hidden="true">✍️</span> Add your name · <span data-porch-price></span>';
        add.dataset.variant = m.variant; add.querySelector('[data-porch-price]').textContent = m.price; add.disabled = !m.variant;
      }
      const link = this.$('[data-porch-link]'); if (link) link.href = m.url;
      let img;
      try { img = await loadImg(m.flat); } catch (e) { try { img = await loadImg(m.img); } catch (e2) { return; } }
      if (this.mat !== m) return;
      this.matCanvas = this.buildMat(img, /round/.test(m.handle));
      this.draw();
    }
    buildMat(img, round) {
      const W = 600, H = Math.round(W * (img.naturalHeight / img.naturalWidth)) || 400;
      const c = document.createElement('canvas'); c.width = W; c.height = H; const x = c.getContext('2d');
      x.save(); x.beginPath();
      if (round) x.ellipse(W / 2, H / 2, W / 2, H / 2, 0, 0, Math.PI * 2);
      else { const r = 18; x.moveTo(r, 0); x.arcTo(W, 0, W, H, r); x.arcTo(W, H, 0, H, r); x.arcTo(0, H, 0, 0, r); x.arcTo(0, 0, W, 0, r); x.closePath(); }
      x.clip();
      x.fillStyle = '#2a2a2a'; x.fillRect(0, 0, W, H);
      const b = round ? 10 : 12; x.drawImage(img, b, b, W - b * 2, H - b * 2);
      // fibre texture + soft light so it reads as a real mat
      const n = x.getImageData(0, 0, W, H), d = n.data;
      for (let i = 0; i < d.length; i += 4) { const v = (Math.random() - 0.5) * 22; d[i] += v; d[i + 1] += v; d[i + 2] += v; }
      x.putImageData(n, 0, 0);
      const g = x.createLinearGradient(0, 0, 0, H); g.addColorStop(0, 'rgba(255,255,255,0.08)'); g.addColorStop(1, 'rgba(0,0,0,0.12)');
      x.fillStyle = g; x.fillRect(0, 0, W, H);
      x.restore();
      return c;
    }
    matGeom() {
      const cw = this.canvas.width, ch = this.canvas.height, s = this.state, mc = this.matCanvas;
      const w = s.w * cw, aspect = mc ? mc.height / mc.width : 2 / 3;
      const h = w * aspect * (1 - 0.62 * s.tilt), topW = w * (1 - 0.32 * s.tilt);
      return { x: s.cx * cw, y: s.cy * ch, w, h, topW };
    }
    drawMatOn(ctx) {
      if (!this.matCanvas) return;
      const g = this.matGeom(), mc = this.matCanvas, N = 90;
      ctx.save(); ctx.translate(g.x, g.y); ctx.rotate(this.state.rot);
      // contact shadow
      ctx.save(); ctx.filter = 'blur(' + Math.max(2, g.w * 0.02) + 'px)'; ctx.fillStyle = 'rgba(0,0,0,0.38)';
      ctx.beginPath(); ctx.moveTo(-g.topW / 2, -g.h / 2 + 4); ctx.lineTo(g.topW / 2, -g.h / 2 + 4); ctx.lineTo(g.w / 2 + 3, g.h / 2 + 5); ctx.lineTo(-g.w / 2 - 3, g.h / 2 + 5); ctx.closePath(); ctx.fill(); ctx.restore();
      // perspective strips (far edge narrower, rows compress toward the top)
      for (let i = 0; i < N; i++) {
        const t0 = i / N, t1 = (i + 1) / N;
        const e0 = Math.pow(t0, 1 + this.state.tilt * 0.5), e1 = Math.pow(t1, 1 + this.state.tilt * 0.5);
        const y0 = -g.h / 2 + g.h * e0, y1 = -g.h / 2 + g.h * e1;
        const w = g.topW + (g.w - g.topW) * ((t0 + t1) / 2);
        ctx.drawImage(mc, 0, mc.height * t0, mc.width, mc.height / N + 0.5, -w / 2, y0, w, (y1 - y0) + 0.6);
      }
      ctx.restore();
    }
    draw() {
      const c = this.ctx, cw = this.canvas.width, ch = this.canvas.height;
      c.clearRect(0, 0, cw, ch);
      if (this.photo) c.drawImage(this.photo, 0, 0, cw, ch);
      this.drawMatOn(c);
    }
    async render(withBadge) {
      const out = document.createElement('canvas'); out.width = this.canvas.width; out.height = this.canvas.height;
      const x = out.getContext('2d');
      if (this.photo) x.drawImage(this.photo, 0, 0);
      this.drawMatOn(x);
      if (withBadge) {
        const s = Math.max(1, out.width / 900), txt = 'Previewed at ShopDoorMates.com';
        x.font = `600 ${Math.round(18 * s)}px Fredoka, Nunito, system-ui, sans-serif`;
        const tw = x.measureText(txt).width, pw = tw + 30 * s, ph = 34 * s, px = out.width - pw - 14 * s, py = out.height - ph - 14 * s;
        x.fillStyle = 'rgba(255,210,63,0.95)'; x.strokeStyle = '#2B2D42'; x.lineWidth = 2 * s;
        x.beginPath(); x.moveTo(px + ph / 2, py); x.arcTo(px + pw, py, px + pw, py + ph, ph / 2); x.arcTo(px + pw, py + ph, px, py + ph, ph / 2); x.arcTo(px, py + ph, px, py, ph / 2); x.arcTo(px, py, px + pw, py, ph / 2); x.closePath(); x.fill(); x.stroke();
        x.fillStyle = '#2B2D42'; x.textBaseline = 'middle'; x.fillText(txt, px + 15 * s, py + ph / 2 + 1);
      }
      return new Promise(res => out.toBlob(b => res(b), 'image/jpeg', 0.92));
    }
    async save() {
      const blob = await this.render(true); if (!blob) return;
      const name = 'my-porch-' + (this.mat ? this.mat.handle : 'doormat') + '.jpg';
      const file = new File([blob], name, { type: 'image/jpeg' });
      const coarse = window.matchMedia && matchMedia('(pointer: coarse)').matches;
      try {
        if (coarse && navigator.canShare && navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], title: 'My porch + ShopDoorMate' }); return; }
      } catch (e) { if (e && e.name === 'AbortError') return; }
      const url = URL.createObjectURL(blob), a = document.createElement('a');
      a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 4000);
      this.toast('Picture saved! Show it off to your friends.', 3000);
      this.root.dataset.saved = name;
    }
    async addToCart(btn) {
      if (this.mat && this.mat.pz) { window.location.href = this.mat.url; return; }
      const id = btn.dataset.variant; if (!id) return;
      btn.disabled = true;
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) });
        if (!r.ok) throw new Error('add failed');
        const cart = await (await fetch('/cart.js')).json();
        try { const ev = new Event('shopify:cart:lines-update', { bubbles: true }); ev.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { itemCount: cart.item_count } }); document.dispatchEvent(ev); } catch (e) {}
        this.toast(`<b>${this.mat.title}</b> is in your cart! <a href="/cart" class="sdm-porch__toast-link">Go to cart →</a>`, 6000);
      } catch (e) { this.toast('Could not add it right now. Please try again.', 3000); }
      finally { btn.disabled = false; }
    }
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-sdm-porch]').forEach(el => { if (!el.__sdm) el.__sdm = new PorchPreview(el); }); }
  window.SDMPorchBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
})();
